module.exports = __webpack_public_path__ + "img/dis01.2cc33134.svg";